<template>
  <button
    class="t-button"
    :class="classes"
    :type="nativeType"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span class="t-button__left" v-if="$slots.left"><slot name="left"></slot></span>
    <slot></slot>
    <span class="t-button__right" v-if="$slots.right"><slot name="right"></slot></span>
  </button>
</template>

<script>
import ButtonColorTypeMixin from '../../mixins/ButtonColorTypeMixin';
import { buttonTypes } from '../../enums';

export default {
  name: 't-button',
  mixins: [ButtonColorTypeMixin],
  props: {
    soft: Boolean,
    compact: Boolean,
    outlined: Boolean,
    block: Boolean,
    wide: Boolean,
    small: Boolean,
    square: Boolean,
    nativeType: {
      type: String,
      default: buttonTypes.BUTTON,
      validator: (value) => Object.values(buttonTypes).includes(value),
    },
  },
  computed: {
    classes() {
      return [`t-button--${this.type}`,
        {
          't-button--compact': this.compact,
          't-button--outline': this.outlined,
          't-button--soft': this.soft,
          't-button--block': this.block,
          't-button--wide': this.wide,
          't-button--small': this.small,
          't-button--square': this.square,
        }];
    },
  },
};
</script>
